export const colors = {
  white: '#ffffff',
  black: '#333333',
  primary: '#F9BF3B',
  secondary: '#F39C12',
  dark: '#22313F',
  grey: '#58595b',
  lightGrey: '#d3d3d3',
}
